/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import BaseModel from "./Model";

export default interface BasePriceTarget extends BaseModel {
    Name?: string;
    Description?: string;
    Unique?: boolean;
}
